import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

const DialogContext = createContext<null | VoidFunction>(null);

const DialogProvider = DialogContext.Provider;

function useDialogClose(): VoidFunction {
	return useRequiredContext(DialogContext, { providerName: "Dialog" });
}

export { DialogProvider, useDialogClose };
